<template>
    <div class="helpCenter">
        <div class="help-div">
            <div class="help-left">
                <img class="help-title" src="../assets/help-wc.png" alt="" style="visibility: hidden;" />
                <div class="help-search">
                    <el-input placeholder="请输入您遇到的问题，搜索获取解决方案" suffix-icon="el-icon-search" v-model="searchValue"
                        class="search-class" @change="searchHelp">
                    </el-input>
                </div>
            </div>
            <div class="help-right">
                <div class="hot-title">
                    <img src="../assets/help-hot.png" alt="" />
                    <span>热门问题</span>
                </div>
                <div class="hot-list">
                    <div class="list-box" v-for="item in helpData" :key="item.id" @click="gotoDetail(item)">
                        <div>{{ item.title }}</div>
                        <img src="../assets/help-jian.png" alt="" />
                    </div>
                    <!-- <div class="help-page">
                        <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageindex"
                            :page-size="pagesize" layout="total, prev, pager, next" :total="total">
                        </el-pagination>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { helpListApi } from "../api/api.js";
export default {
    name: "HelpCenter",
    data() {
        return {
            searchValue: "",
            helpData: [],
            total: 0,
            pageindex: 1,
            pagesize: 5
        };
    },
    components: {},
    mounted() {
        this.helpList()
    },
    methods: {
        gotoDetail(item) {
            this.$router.push({
                path: "/helpDetail",
                query: {
                    detail: JSON.stringify(item),
                }
            });
        },
        async helpList() {
            const res = await helpListApi({
                pageindex: this.pageindex,
                // pagesize: this.pagesize,
                pagesize: 6,
                cateType: 5,
                title: this.searchValue
            });
            this.helpData = res.data.data.records;
            this.total = res.data.data.total
        },
        handleCurrentChange() {
            this.helpList()
        },
        searchHelp() {
            this.helpList()
        }
    },
};
</script>
<style lang="scss" scoped>
.helpCenter {
    width: 100vw;
    height: 1411px;
    background: url("../assets/help-bg.png");
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
}

.help-div {
    width: 70%;
    height: 60%;
    display: flex;
    justify-content: space-between;

    // background: pink;
    .help-left {
        .help-title {
            width: 659px;
        }

        .help-search {
            margin-top: 200px;
            width: 638px;
        }
    }

    .help-right {
        width: 474px;
        height: 619px;
        border-radius: 5px;
        background: #141414;
        padding: 25px;

        .hot-title {
            display: flex;
            align-items: center;
            padding: 20px 0;
            border-bottom: 1px solid #ff9000;

            img {
                width: 26px;
                padding-right: 10px;
            }

            span {
                color: #fff;
                font-size: 18px;
                font-weight: bold;
            }
        }

        .hot-list {
            .list-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #ababab;
                padding: 30px 0;
                border-bottom: 1px solid #505050;
                cursor: pointer;

                div {
                    font-size: 22px;
                    white-space: nowrap;
                    /* 不换行 */
                    overflow: hidden;
                    /* 隐藏超出的内容 */
                    text-overflow: ellipsis;
                    /* 用省略号表示被隐藏的部分 */
                    max-width: 70%;
                    /* 设置最大宽度以限制文本的显示长度 */
                }

                img {
                    width: 16px;
                }
            }

            .help-page {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 50px;
            }
        }
    }
}

::v-deep .el-input__inner {
    background: #181818;
    // height: 79px;
    padding: 30px 40px;
    border: 1px solid #8d8d8d;
    color: #fff;
}
</style>
